import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { forwardRef } from 'react';
import { getTestId } from '../../utils/testId.js';
import { jsx } from 'react/jsx-runtime';

var classnamesExports = {};
var classnames = {
  get exports(){ return classnamesExports; },
  set exports(v){ classnamesExports = v; },
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var classNames = classnamesExports;

var styles = {
  "box-reset": "playground__Box__box-reset",
  "a": "playground__Box__a",
  "box": "playground__Box__box",
  "outline-none": "playground__Box__outline-none",
  "outline-default": "playground__Box__outline-default",
  "outline-medium": "playground__Box__outline-medium",
  "outline-round": "playground__Box__outline-round",
  "box-opacity-level-none": "playground__Box__box-opacity-level-none",
  "box-opacity-level-1": "playground__Box__box-opacity-level-1",
  "box-opacity-level-2": "playground__Box__box-opacity-level-2",
  "box-opacity-level-3": "playground__Box__box-opacity-level-3",
  "box-opacity-level-4": "playground__Box__box-opacity-level-4",
  "box-opacity-level-5": "playground__Box__box-opacity-level-5",
  "box-opacity-level-6": "playground__Box__box-opacity-level-6",
  "box-opacity-level-7": "playground__Box__box-opacity-level-7",
  "box-opacity-level-8": "playground__Box__box-opacity-level-8",
  "box-opacity-level-max": "playground__Box__box-opacity-level-max",
  "box-theme-greyscale-5": "playground__Box__box-theme-greyscale-5",
  "box-theme-greyscale-6": "playground__Box__box-theme-greyscale-6",
  "box-theme-primary-extra-light": "playground__Box__box-theme-primary-extra-light",
  "overflow-auto": "playground__Box__overflow-auto",
  "overflow-clip": "playground__Box__overflow-clip",
  "overflow-visible": "playground__Box__overflow-visible",
  "overflow-hidden": "playground__Box__overflow-hidden",
  "width-parent": "playground__Box__width-parent",
  "width-content": "playground__Box__width-content",
  "width-custom": "playground__Box__width-custom",
  "height-parent": "playground__Box__height-parent",
  "height-content": "playground__Box__height-content",
  "height-custom": "playground__Box__height-custom",
  "border-none": "playground__Box__border-none",
  "border-default": "playground__Box__border-default",
  "border-active": "playground__Box__border-active",
  "border-inverse": "playground__Box__border-inverse",
  "padding-tight": "playground__Box__padding-tight",
  "padding-narrow": "playground__Box__padding-narrow",
  "padding-default": "playground__Box__padding-default",
  "padding-wide": "playground__Box__padding-wide",
  "padding-top-tight": "playground__Box__padding-top-tight",
  "padding-top-narrow": "playground__Box__padding-top-narrow",
  "padding-top-default": "playground__Box__padding-top-default",
  "padding-top-wide": "playground__Box__padding-top-wide",
  "padding-right-tight": "playground__Box__padding-right-tight",
  "padding-right-narrow": "playground__Box__padding-right-narrow",
  "padding-right-default": "playground__Box__padding-right-default",
  "padding-right-wide": "playground__Box__padding-right-wide",
  "padding-bottom-tight": "playground__Box__padding-bottom-tight",
  "padding-bottom-narrow": "playground__Box__padding-bottom-narrow",
  "padding-bottom-default": "playground__Box__padding-bottom-default",
  "padding-bottom-wide": "playground__Box__padding-bottom-wide",
  "padding-left-tight": "playground__Box__padding-left-tight",
  "padding-left-narrow": "playground__Box__padding-left-narrow",
  "padding-left-default": "playground__Box__padding-left-default",
  "padding-left-wide": "playground__Box__padding-left-wide",
  "padding-top-spacer-none-0": "playground__Box__padding-top-spacer-none-0",
  "padding-top-spacer-x-small-2px": "playground__Box__padding-top-spacer-x-small-2px",
  "padding-top-spacer-small-4px": "playground__Box__padding-top-spacer-small-4px",
  "padding-top-spacer-regular-8px": "playground__Box__padding-top-spacer-regular-8px",
  "padding-top-spacer-medium-12px": "playground__Box__padding-top-spacer-medium-12px",
  "padding-top-spacer-large-16px": "playground__Box__padding-top-spacer-large-16px",
  "padding-top-spacer-larger-20px": "playground__Box__padding-top-spacer-larger-20px",
  "padding-top-spacer-x-large-24px": "playground__Box__padding-top-spacer-x-large-24px",
  "padding-top-spacer-x-larger-28px": "playground__Box__padding-top-spacer-x-larger-28px",
  "padding-top-spacer-x2-large-32px": "playground__Box__padding-top-spacer-x2-large-32px",
  "padding-right-spacer-none-0": "playground__Box__padding-right-spacer-none-0",
  "padding-right-spacer-x-small-2px": "playground__Box__padding-right-spacer-x-small-2px",
  "padding-right-spacer-small-4px": "playground__Box__padding-right-spacer-small-4px",
  "padding-right-spacer-regular-8px": "playground__Box__padding-right-spacer-regular-8px",
  "padding-right-spacer-medium-12px": "playground__Box__padding-right-spacer-medium-12px",
  "padding-right-spacer-large-16px": "playground__Box__padding-right-spacer-large-16px",
  "padding-right-spacer-larger-20px": "playground__Box__padding-right-spacer-larger-20px",
  "padding-right-spacer-x-large-24px": "playground__Box__padding-right-spacer-x-large-24px",
  "padding-right-spacer-x-larger-28px": "playground__Box__padding-right-spacer-x-larger-28px",
  "padding-right-spacer-x2-large-32px": "playground__Box__padding-right-spacer-x2-large-32px",
  "padding-bottom-spacer-none-0": "playground__Box__padding-bottom-spacer-none-0",
  "padding-bottom-spacer-x-small-2px": "playground__Box__padding-bottom-spacer-x-small-2px",
  "padding-bottom-spacer-small-4px": "playground__Box__padding-bottom-spacer-small-4px",
  "padding-bottom-spacer-regular-8px": "playground__Box__padding-bottom-spacer-regular-8px",
  "padding-bottom-spacer-medium-12px": "playground__Box__padding-bottom-spacer-medium-12px",
  "padding-bottom-spacer-large-16px": "playground__Box__padding-bottom-spacer-large-16px",
  "padding-bottom-spacer-larger-20px": "playground__Box__padding-bottom-spacer-larger-20px",
  "padding-bottom-spacer-x-large-24px": "playground__Box__padding-bottom-spacer-x-large-24px",
  "padding-bottom-spacer-x-larger-28px": "playground__Box__padding-bottom-spacer-x-larger-28px",
  "padding-bottom-spacer-x2-large-32px": "playground__Box__padding-bottom-spacer-x2-large-32px",
  "padding-left-spacer-none-0": "playground__Box__padding-left-spacer-none-0",
  "padding-left-spacer-x-small-2px": "playground__Box__padding-left-spacer-x-small-2px",
  "padding-left-spacer-small-4px": "playground__Box__padding-left-spacer-small-4px",
  "padding-left-spacer-regular-8px": "playground__Box__padding-left-spacer-regular-8px",
  "padding-left-spacer-medium-12px": "playground__Box__padding-left-spacer-medium-12px",
  "padding-left-spacer-large-16px": "playground__Box__padding-left-spacer-large-16px",
  "padding-left-spacer-larger-20px": "playground__Box__padding-left-spacer-larger-20px",
  "padding-left-spacer-x-large-24px": "playground__Box__padding-left-spacer-x-large-24px",
  "padding-left-spacer-x-larger-28px": "playground__Box__padding-left-spacer-x-larger-28px",
  "padding-left-spacer-x2-large-32px": "playground__Box__padding-left-spacer-x2-large-32px",
  "no-top-right": "playground__Box__no-top-right",
  "no-top-left": "playground__Box__no-top-left",
  "no-bottom-right": "playground__Box__no-bottom-right",
  "no-bottom-left": "playground__Box__no-bottom-left"
};

var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _context;
  var id = _ref.id,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'greyscale-6' : _ref$theme,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? 'visible' : _ref$overflow,
    children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'parent' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'parent' : _ref$height,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'default' : _ref$border,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'default' : _ref$padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 'default' : _ref$radius,
    _ref$noRadiusTopLeft = _ref.noRadiusTopLeft,
    noRadiusTopLeft = _ref$noRadiusTopLeft === void 0 ? false : _ref$noRadiusTopLeft,
    _ref$noRadiusTopRight = _ref.noRadiusTopRight,
    noRadiusTopRight = _ref$noRadiusTopRight === void 0 ? false : _ref$noRadiusTopRight,
    _ref$noRadiusBottomLe = _ref.noRadiusBottomLeft,
    noRadiusBottomLeft = _ref$noRadiusBottomLe === void 0 ? false : _ref$noRadiusBottomLe,
    _ref$noRadiusBottomRi = _ref.noRadiusBottomRight,
    noRadiusBottomRight = _ref$noRadiusBottomRi === void 0 ? false : _ref$noRadiusBottomRi,
    testId = _ref.testId;
  var Component = as;
  var cssClasses = classNames.bind(styles);
  var isCustomWidth = width !== 'parent' && width !== 'content';
  var isCustomHeight = height !== 'parent' && height !== 'content';
  var widthClass = classNames(_defineProperty(_defineProperty(_defineProperty({}, styles['width-parent'], width === 'parent'), styles['width-content'], width === 'content'), styles['width-custom'], isCustomWidth));
  var heightClass = classNames(_defineProperty(_defineProperty(_defineProperty({}, styles['height-parent'], height === 'parent'), styles['height-content'], height === 'content'), styles['height-custom'], isCustomHeight));
  var style = _objectSpread(_objectSpread({}, isCustomWidth ? {
    '--box-width': typeof width === 'number' ? "".concat(width, "px") : width
  } : {}), isCustomHeight ? {
    '--box-height': typeof height === 'number' ? "".concat(height, "px") : height
  } : {});
  var edgeRadiusStyles = [];
  if (noRadiusTopLeft) edgeRadiusStyles.push(styles['no-top-left']);
  if (noRadiusTopRight) edgeRadiusStyles.push(styles['no-top-right']);
  if (noRadiusBottomRight) edgeRadiusStyles.push(styles['no-bottom-right']);
  if (noRadiusBottomLeft) edgeRadiusStyles.push(styles['no-bottom-left']);
  var boxClass = cssClasses.apply(void 0, _concatInstanceProperty(_context = [styles.box, [styles["overflow-".concat(overflow)]], [styles["border-".concat(border)]], [styles["box-theme-".concat(theme)]], [styles["padding-".concat(padding)]], paddingTop ? [styles["padding-top-".concat(paddingTop)]] : undefined, paddingRight ? [styles["padding-right-".concat(paddingRight)]] : undefined, paddingBottom ? [styles["padding-bottom-".concat(paddingBottom)]] : undefined, paddingLeft ? [styles["padding-left-".concat(paddingLeft)]] : undefined, [styles["outline-".concat(radius)]], widthClass, heightClass]).call(_context, edgeRadiusStyles));
  return /*#__PURE__*/jsx(Component, {
    "data-id": id,
    "data-testid": getTestId(testId, 'parent'),
    role: role,
    tabIndex: tabIndex,
    className: boxClass,
    ref: ref,
    style: style,
    children: children
  });
});

export { Box as default };
//# sourceMappingURL=Box.js.map
